import { to_array } from "./to_array"

export const last = any => {
  const arr = to_array(any)
  return arr[arr.length - 1]
}
